var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1Train(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 14H1v4h41.81l-11.24 7 11.24 7H25v20h49v-7c0-3.71-1.86-10.23-8-13H44l10.44-7L44 18h31v-4zM56 45H30v-3h26v3zm6-9h3c3.91 2.19 5 6.77 5 9h-8v-9zm-6 0v3H30v-3h26zm-8.75-11l-3.91 2.62-4.2-2.62 4.2-2.62L47.25 25zM25 55h49v4h-3.73a3 3 0 01-5.89.62l-.07-.45V59H63c-.002.21-.036.42-.1.62a3 3 0 01-5.78 0l-.12-.45V59H41.15a2.51 2.51 0 01-.09.62 3 3 0 01-5.79 0l-.08-.45V59h-1.11a3 3 0 01-5.89.62l-.07-.45V59H25v-4zM1 55h21v4h-3c-.002.21-.036.42-.1.62a3 3 0 01-5.78 0l-.12-.45V59H1v-4zm0-3h21V32H1v20zm8-16h7v9H9v-9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Train.a5ee69da.svg";
export { SvgI1Train as ReactComponent };